export default __webpack_public_path__ + "static/program-fundusz-inicjatyw-obywatelskich-f11a2560385e85de6fd9f200d46dddc2.jpg";